import React, { useEffect } from 'react';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import LoginForm from "../components/LoginForm";
import ProfileForm from "../components/ProfileForm";
import { useAuth } from '../AuthContext';

const Profile = () => {
  const { currentUser, logout, sendSignInLinkToEmail } = useAuth();
  const auth = getAuth();

  const handleLogin = (email) => {
    const actionCodeSettings = {
      url: window.location.href, // This URL should be the URL of the page where you handle the sign-in link
      handleCodeInApp: true,
    };

    sendSignInLinkToEmail(email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem('emailForSignIn', email);
      })
      .catch((error) => {
        console.error('Failed to send sign-in link:', error);
      });
  };

  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt('Please provide your email for confirmation');
      }

      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          window.localStorage.removeItem('emailForSignIn');
          // User is signed in, you can redirect them now
        })
        .catch((error) => {
          console.error('Error signing in with email link:', error);
        });
    }
  }, []);

  return (
    <div className="container profile-desc">
      <h2>Profile</h2>
      
      {currentUser ? (
        <div>
          <p>Email: {currentUser.email}</p>
          <ProfileForm />
        </div>
        
      ) : (
        <><p>Please log in to update your profile.</p><LoginForm onLogin={handleLogin} /></>
      )}
    
    </div>
  );
};

export default Profile;